import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col overflow-y-auto pb-32" }

import { initWorkspace } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

initWorkspace();

return (_ctx: any,_cache: any) => {
  const _component_the_header = _resolveComponent("the-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_the_modal_portal = _resolveComponent("the-modal-portal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_the_header),
    _createVNode(_component_router_view),
    _createVNode(_component_the_modal_portal)
  ]))
}
}

})